import { render, staticRenderFns } from "./dataPrivilegeStaff.vue?vue&type=template&id=678dcd7e&scoped=true"
import script from "./dataPrivilegeStaff.vue?vue&type=script&lang=js"
export * from "./dataPrivilegeStaff.vue?vue&type=script&lang=js"
import style0 from "./dataPrivilegeStaff.vue?vue&type=style&index=0&id=678dcd7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678dcd7e",
  null
  
)

export default component.exports